
import consumablesPools from "@/const/consumables/pools";
import { Consumables } from "@/const/consumables/type";
import GoodItem from "./GoodItem.vue";
export default {
  components: { GoodItem },
  setup() {
    const consumablesStoreList: Consumables[] = [
      consumablesPools.get("小红药"),
      consumablesPools.get("中红药"),
      consumablesPools.get("章鱼烧")
    ];
    return { consumablesStoreList };
  }
};
